export default __webpack_public_path__ + "static/media/MainIcon1.ec1bdcec.svg";